import { Link } from "react-router-dom";
import t from "../translate";

function BottomNavBar() {
    return <div className="bottom-nav-bar">
        <Link to="/" className="navbar-item">
            <img src="/assets/icons/ic_joystick.svg" className="navbar-icon" alt="ic_joystick" />
            <p>{t(localStorage.getItem('lang') || 'en', 'play')} </p>
        </Link>
        <Link to="/leaderboard" className="navbar-item">
            <img src="/assets/icons/ic_handshake.svg" className="navbar-icon" alt="ic_handshake" />
            <p>{t(localStorage.getItem('lang') || 'en', 'friends')}</p>
        </Link>
        <Link to="/withdraw" className="navbar-item">
            <img src="/assets/icons/ic_money.svg" className="navbar-icon" alt="ic_money" />
            <p>{t(localStorage.getItem('lang') || 'en', 'withdraw')}</p>
        </Link>
        <Link to="/spin" className="navbar-item">
            <img src="/assets/icons/ic_spiner.svg" className="navbar-icon" alt="ic_spiner" />
            <p>{t(localStorage.getItem('lang') || 'en', 'spin_button')}</p>
        </Link>
    </div>
}

export default BottomNavBar;